export default __webpack_public_path__ + "static/media/010-Russian hat.e4f134da.svg";